import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export type DeleteConversationDialogProps = {
  open: boolean;
  conversationName: string;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteConversationDialog = ({
  open,
  conversationName,
  onClose,
  onConfirm,
}: DeleteConversationDialogProps) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Delete conversation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The conversation <strong>{conversationName}</strong> will be
          permanently deleted.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 2, gap: 1 }}>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={handleConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConversationDialog;
